import { getObjectFromFormData } from '@js/utilities/formData';
import { halfSizeListener } from '@js/pages/product/halfSizeListener';

window.addEventListener('remoteContent.#product-options.loaded', async () => {
    // const { container } = e.detail;

    document.querySelectorAll('.js-engrave-module.collapse').forEach((el) => {
        el.addEventListener('load-engrave-module', async () => {
            const { initEngraveModule } = await import('@js/pages/product/engrave/engrave');

            initEngraveModule(el);
        });

        el.addEventListener('shown.bs.collapse', () => {
            if (el.engraveInitialized) {
                el.engraveModule?.update();
                return;
            }

            el.dispatchEvent(new CustomEvent('load-engrave-module'));

            el.engraveInitialized = true;
        });

        const engraveTextInput = el.querySelector('.js-engrave-text');
        if (engraveTextInput?.value) {
            el.dispatchEvent(new CustomEvent('load-engrave-module'));
        }
    });

    // const engraveContainers = container.querySelectorAll('.js-engrave-module');

    // const { initEngraveModule } = await import(
    //     '@js/pages/product/engrave/engrave'
    // );

    // engraveContainers.forEach((el) => {
    //     initEngraveModule(el);
    // });
});

window.addEventListener('remoteModal.#modal-returns-configure-product.loaded', async (e) => {
    const { modal } = e.detail;
    const formElement = modal.querySelector('.js-returns-configure-new-model-form');

    const { init } = await import('@js/pages/product/wedding-configurator/weddingConfigurator');

    init();

    // if (document.querySelector('.js-wedding-configurator-container')) {

    // }

    formElement.addEventListener('submit', async (ev) => {
        ev.preventDefault();

        const formData = new FormData(formElement);

        window.dispatchEvent(
            new CustomEvent('configure-product-modal-closed', {
                detail: {
                    data: getObjectFromFormData(formData),
                },
            })
        );

        window.bootstrap.Modal.getInstance(modal).hide();
    });
});

window.addEventListener('remoteContent.#product-options.loaded', async () => {
    const { init } = await import('@js/pages/product/wedding-configurator/weddingConfigurator');

    init();

    halfSizeListener();
});

const hiddenInputsContainer = document.querySelector('.js-service-exchange-hidden-inputs');

window.addEventListener('configure-product-modal-closed', async (e) => {
    const { data } = e.detail;

    console.log(data);

    hiddenInputsContainer.innerHTML = '';

    Object.keys(data).forEach((optionName) => {
        const input = document.createElement('input');

        input.type = 'hidden';
        input.name = optionName;
        input.value = data[optionName];

        hiddenInputsContainer.append(input);
    });

    const optionsString = Object.keys(data)
        .map((optionKey) => `${optionKey}=${data[optionKey]}`)
        .join('&');

    const response = await fetch(
        `/api/issue/get_product_info?model=${window.returnsFormData.newModel}&${optionsString}`
    );

    if (response.ok) {
        const html = await response.text();

        const newModelContainers = document.querySelectorAll('.js-remote-content-new-model');

        newModelContainers.forEach((el) => {
            el.innerHTML = html;
        });
    }
});
